import { useCallback } from 'react';

import type { BlockerFunction } from './blocker';
import { useBlocker } from './blocker';

export function usePrompt({
  when,
  message,
  onConfirm,
}: {
  when: boolean | BlockerFunction;
  message: string;
  onConfirm?: () => void;
}): void {
  const shouldBlock = useCallback<BlockerFunction>(
    (args) => {
      const blocksNavigation = typeof when === 'boolean' ? when : when(args);

      if (!blocksNavigation) {
        return false;
      }

      const hasConfirmed = window.confirm(message);

      if (hasConfirmed) {
        onConfirm?.();
      }

      return !hasConfirmed;
    },
    [when, message, onConfirm]
  );

  useBlocker(shouldBlock);
}
